module.exports = __webpack_public_path__ + "static/media/communion2.3221921b.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pdfs/hymns/communion2.pdf
// module id = 786
// module chunks = 2